import React from "react";
import { Input, Form } from "antd";
import { Controller } from "react-hook-form";
import { getError } from "../../../utils/form";

/* const itemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    lg: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
}; */

function itemLayout(fullLabelWidth) {
  let layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      lg: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      lg: { span: 14 },
    },
  };

  if (fullLabelWidth === true) {
    layout.labelCol.lg.span = 24;
    // layout.wrapperCol.lg.span = 24;
  }

  return layout;
}

const ControlledInput = ({
  control,
  errors,
  name,
  label,
  required,
  type = "text",
  fullLabelWidth = "false",
  disabled,
  min,
  max,
  onChange,
  index = 0,
}) => {
  const error = getError({ errors, name });
  //console.log("errors input-", error);
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          label={label}
          //{...itemLayout}
          {...itemLayout(fullLabelWidth)}
          required={required}
          labelAlign="left"
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          {type === "number" ? (
            <Input
              type={type}
              {...field}
              disabled={disabled}
              min={min}
              max={max}
              onPaste={(event) => {
                if (type === "number") {
                  event.preventDefault();
                }
              }}
              onKeyDown={(event) => {
                if (type === "number") {
                  if (
                    event.key === "." ||
                    event.key === "e" ||
                    event.key === "-" ||
                    event.key === "+"
                  ) {
                    event.preventDefault();
                  }
                }
              }}
              onFocus={() => {
                let el = document.getElementsByName(name);
                el = el[0];
                el.setAttribute("autocomplete", "autocomplete_off");
                // el.setAttribute("id", `${label}_`);
              }}
              onChange={(e) => {
                field.onChange(e.target.value);
                if (onChange) {
                  onChange(e.target.value, index);
                }
              }}
            />
          ) : (
            <Input
              type={type}
              {...field}
              disabled={disabled}
              onFocus={() => {
                let el = document.getElementsByName(name);
                el = el[0];
                el.setAttribute("autocomplete", "autocomplete_off");
                el.setAttribute("id", `${label}_`);
              }}
            />
          )}
        </Form.Item>
      )}
    />
  );
};

export default ControlledInput;
